// extracted by mini-css-extract-plugin
export default {"deleteMessage":"ConfirmDeleteModal_deleteMessage__FsgVa"};